export default {
    message: {
        buscar_calles: 'Buscador de calles...',
        valenciano: 'Valenciano',
        castellano: 'Castellano',
    },

    escenario: 'Escenario',

    panel_layers: {
        btn_catalogo: 'Catálogo',
    },

    "paginacion": {
        "anterior": "Anterior",
        "siguiente": "Siguiente",
    },

    capas_encontradas: 'capas encontradas',
    no_resultados: 'No hay resultados',
    no_descripcion: 'No hay descripción.',
    ver_en_mapa: 'Ver en mapa',

    descargar_capa: 'Descargar capa',
    catalogo_desactivado: 'Temporalmente están deshabilitados los servicios del catálogo. No obstante puedes ponerte en contacto con nosotros a través del formulario de sugerencia o de info@sigogestion.com. Si necesitas que te facilitemos alguna capa o acceso al servicio. En breve volverás a estar operativos. Disculpa las molestias.',
    informacion: 'Información',
    volver_al_catalogo: 'Volver al catálogo',
    campos: {
        titulo: "Título",
        descripcion: "Descripción",
        fecha_publicacion: "Fecha publicación",
        fecha_actualizacion: "Fecha actualización",
    },
    atributos: 'Atributos',
    campos_atributos: {
        nombre: 'Nombre del atributo',
        etiqueta: 'Etiqueta',
        descripcion: 'Descripción',
    },
    no_attributos: 'No hay atributos',

    panel_filtros: {
        titulo: 'Filtros',
        limpiar: 'Limpiar',
        texto: 'Texto',
        grupo: 'Grupo',
        buscar: 'Buscar'
    },
}

